<template>
    <dash
        icon="fa fa-dollar"
        titulo="PAGAMENTOS"
        @click.native="$router.push(rota)"
        :qtd="qtd"
        :mostrarQtd="true"
        :loading="loading"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
	props: {
		rota: {
			type: Object,
			default: () => ({
				name: 'FornecedorPagamentos'
			})
		},

		qtd: {
			type: Number
		},

		loading: {
			type: Boolean
		}
	},

	components: {
		Dash
	},

	data() {
		return {}
	}
}
</script>
